import $axios from '~/plugins/axios';
import { buildModule } from '../utils';
import { Api, CampaignSplitOrder, CampaignSplitOrderLight, CampaignVisual, CampaignVisualRequest, GetCampaignVisualIdOrdersParams } from '~/api';
import { Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedCampaignVisuals: {} as Dict<CampaignVisual>,
		storedCampaignVisualOrders: {} as Dict<CampaignSplitOrder[]>,
	})
	.withGetters({
		byId: state => (visualId: number): CampaignVisual | null => (
			state.storedCampaignVisuals[visualId] ?? null
		),
		ordersById: state => (visualId: number): CampaignSplitOrder[] => (
			state.storedCampaignVisualOrders[visualId] ?? []
		),
	})
	.withMutations({
		STORE_CAMPAIGN_VISUAL (state, campaignVisual: CampaignVisual) {
			state.storedCampaignVisuals = {
				...state.storedCampaignVisuals,
				[campaignVisual.id]: campaignVisual,
			};
		},
		STORE_CAMPAIGN_VISUAL_ORDERS (state, { visualId, orders }: { visualId: number; orders: CampaignSplitOrderLight[] }) {
			state.storedCampaignVisualOrders = {
				...state.storedCampaignVisualOrders,
				[visualId]: orders,
			};
		},
	})
	.withActions({
		async get ({ commit }, campaignId: number) {
			const { data } = await api.get(`/campaign-visual/${ campaignId }`);

			commit('STORE_CAMPAIGN_VISUAL', data.payload);
		},
		async getOrders ({ commit }, { visualId, ...params }: { visualId: number } & GetCampaignVisualIdOrdersParams) {
			const { data } = await api.get(`/campaign-visual/${ visualId }/orders/`, { params });

			commit('STORE_CAMPAIGN_VISUAL_ORDERS', { visualId, orders: data.payload });
		},
		async post ({ commit }, campaignVisual: CampaignVisualRequest) {
			const { data } = await api.post('/campaign-visual', campaignVisual);

			commit('STORE_CAMPAIGN_VISUAL', data.payload);

			return data.payload;
		},
		async update ({ commit }, { id, ...campaign }: {
			id: number;
		} & CampaignVisualRequest) {
			const { data } = await api.put(`/campaign-visual/${ id }`, campaign);

			commit('STORE_CAMPAIGN_VISUAL', data.payload);
		},
	});
